import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

function ContactDetails(props) {
  const [formData, setFormData] = useState(props.selectedContact);
  const navigate = useNavigate();

  // Handle back button click
  const handleBackClick = () => {
    navigate(-1);
  };


  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    // Send patch request to update contact details with formData
    fetch(`http://crm.arunexcello.com:3000/change/${formData._id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        // console.log('Success:', data);
        navigate('/');
      })
      .catch((error) => {
        console.error('Error:', error);
      });



  };

  // Handle form input changes
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (formData.Name == null) {
      navigate("/")
    }

  }, [])

  return (
    <>
      <div>
        <h1 id='panelhead'>Edit Contact Details</h1>
        <form onSubmit={handleSubmit} className='centrediv'>
          <label>
            Field:
            <input type="text" name="FIELD" value={formData.FIELD} onChange={handleChange} />
          </label>
          <label>
            Name:
            <input type="text" name="Name" value={formData.Name} onChange={handleChange} />
          </label>
          <br />
          <label>
            Company:
            <input type="text" name="Company" value={formData.Company} onChange={handleChange} />
          </label>
          <br />
          <label>
            Job Title:
            <input type="text" name="Job Title" value={formData['Job Title']} onChange={handleChange} />
          </label>
          <br />
          <label>
            Address:
            <input type="text" name="Address" value={formData.Address} onChange={handleChange} />
          </label>
          <br />
          <label>
            Phone Number:
            <input type="text" name="Phone Number" value={formData['Phone Number']} onChange={handleChange} />
          </label>
          <br />
          <label>
            Email:
            <input type="text" name="Email 1" value={formData['Email']} onChange={handleChange} />
          </label>
          <br />
          <label>
            Websites:
            <input type="text" name="Websites" value={formData.Websites} onChange={handleChange} />
          </label>
          <br />
          <button id='leftpad' onClick={handleBackClick}>Back</button>

          <button type="submit"  >Save</button>
        </form>
      </div>
    </>
  );
}

export default ContactDetails;
